import { ReactNode } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const configuration: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

const pca = new PublicClientApplication(configuration);

export function MSEntraProvider({ children }: { children: ReactNode }) {
  return <MsalProvider instance={pca}>{children}</MsalProvider>;
}
